import { initializeModals } from './snippets/modal';
import { initializeCarousel } from './snippets/carousel';
import { initializeTabstrip } from './snippets/tabstrip';

// Constants
const DATASET_LISTENER_ADDED = 'listenerAdded';
const JSON_CALC_INPUT_SELECTOR = '[data-name-id="jsonCalcInput"]';
const ACCORDION_ITEM_SELECTOR = '.cwx-accordion__item-title';

// Utility Functions
function getJsonCalcInputField() {
  return document.querySelector(JSON_CALC_INPUT_SELECTOR);
}

function getAccordionItems() {
  return document.querySelectorAll(ACCORDION_ITEM_SELECTOR);
}

function addEventListeners(element, events, handler) {
  events.forEach((eventType) => {
    element.removeEventListener(eventType, handler);
    element.addEventListener(eventType, handler);
  });
}

// Accordion Logic
function handleAccordionClick() {
  this.classList.toggle('active');
  const content = this.nextElementSibling;
  content.classList.toggle('open');
}

function initializeAccordion() {
  const accordionItems = getAccordionItems();
  accordionItems.forEach((item) => {
    item.removeEventListener('click', handleAccordionClick);
    item.addEventListener('click', handleAccordionClick);
  });
}

// JSON Input Logic
function populateFormFromJson() {
  const jsonCalcInputField = getJsonCalcInputField();
  if (!jsonCalcInputField) {
    alert('JSON input field not found.');
    return;
  }
  try {
    const jsonData = JSON.parse(jsonCalcInputField.value);
    jsonData.forEach((item) => {
      const field = document.querySelector(`[data-name-id="${item['data-name-id']}"]`);
      if (field) {
        if (!isNaN(item.value) && !isNaN(parseFloat(item.value))) {
          field.value = parseFloat(item.value);
          field.dispatchEvent(new Event('input'));
        } else {
          alert(`Invalid value for field ${item['data-name-id']}: Value must be a valid number.`);
        }
      }
    });
  } catch (e) {
    alert(`Invalid JSON: ${e.message}`);
  }
}

function initializeClipboardCopyToJsonInput() {
  document.addEventListener('keydown', async function (e) {
    const jsonCalcInputField = getJsonCalcInputField();
    if (!jsonCalcInputField) {
      return;
    }

    // Check for Ctrl+V (or Cmd+V on Mac)
    if ((e.ctrlKey || e.metaKey) && e.key === 'v') {
      // Prevent the default paste behavior if needed
      e.preventDefault();

      try {
        // Read text from clipboard
        const text = await navigator.clipboard.readText();

        // Set the clipboard text to the input field
        jsonCalcInputField.value = text;
        populateFormFromJson();
      } catch (err) {
        console.error('Failed to read clipboard contents: ', err);
      }
    }
  });
}

function initializeJsonInput() {
  const jsonInputField = getJsonCalcInputField();
  if (!jsonInputField) {
    return;
  }
  addEventListeners(jsonInputField, ['change', 'paste'], populateFormFromJson);
  initializeClipboardCopyToJsonInput();
}

// Mutation Observer
const observer = new MutationObserver((mutations) => {
  mutations.forEach(() => {
    const jsonInputField = getJsonCalcInputField();
    if (jsonInputField && !jsonInputField.dataset[DATASET_LISTENER_ADDED]) {
      initializeJsonInput();
      jsonInputField.dataset[DATASET_LISTENER_ADDED] = 'true';
    }

    const firstAccordionItem = document.querySelector(ACCORDION_ITEM_SELECTOR)?.firstElementChild;
    if (firstAccordionItem && !firstAccordionItem.dataset[DATASET_LISTENER_ADDED]) {
      initializeAccordion();
      firstAccordionItem.dataset[DATASET_LISTENER_ADDED] = 'true';
    }
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

// Initialization
function initializeApp() {
  initializeAccordion();
  initializeJsonInput();
}

window.addEventListener('is-app-data-fetched', () => {
  initializeModals();
  initializeCarousel();
  initializeTabstrip();
});

initializeApp();
